// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/chevron-compact-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* video background */
.video-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  
  .video-background iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: 56.25vw;
    min-width: 100%;
    min-height: 100%;
    pointer-events: none;
  }
  
  .video-background::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(91deg, #021a5b 22.01%, rgba(17, 28, 71, 0.76) 64.18%, rgba(17, 28, 71, 0.16) 99.56%);
  }
  
  
  /* main content */
  .main-content {
    color: #fff;
    padding-bottom: 50px;
    margin-top: 60px;
    flex-grow: 1;
    width: 100%;
  }
  
  .main-content .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 80%;
    margin: auto;
  }
  
  .content {
    display: flex;
    flex-wrap: wrap;
    gap: 50px;
    justify-content: center;
    width: 100%;
    min-height: 78vh;
  }
  
  .text-column,
  .search-column {
    flex: 1 1 45%;
    min-width: 300px;
    display: flex;
    flex-direction: column;
  }

.text-box,
.search-box {
  display: flex;
  flex-direction: column;
  flex: 1 1;               
}
  /*text column*/
  .text-box {
    justify-content: space-between; 
}

  .text-column h1 {
    font-size: 2.7vw;
    font-weight: 700;
    text-align: left;
    letter-spacing: 1.3px;
    margin-top: 0px;
  }
  
  .text-column p {
    font-size: 1.4vw;
    text-align: left;
    line-height: 1.6;
    letter-spacing: 1.3px;
    padding-bottom: 25px;    

  }
  
  .standout-text {
    color: #f2c74f;
    font-weight: 600;
  }
  
  .text-column-buttons {
    display: flex;
    gap: 15px;
    width: 95%;
  }
  
  .text-column-buttons a {
    flex: 1 1;
    text-align: center;
  }
  
  .text-column-buttons button {
    width: 100%;
    font-size: clamp(1rem, 0.5rem + 1vw, 2.2rem);
    padding: clamp(10px, 6px + 1vw, 22px);
    background-color: #3a89c9;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    letter-spacing: 1.3px;
  }
  
  .text-column_buttons button:hover {
    background-color: #0056b3;
  }

  /*search column*/
  .search-box {
    background: rgba(255, 255, 255, 0.1);
    padding: 40px;
    border-radius: 12px;
    border: 5px solid #9cc4e4;
    text-align: center;
    margin-top: 10px;
    height: auto !important;
  }
  
  .search-box-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .search-box h2 {
    font-size: 1.6vw;
    letter-spacing: 1.3px;
    margin: 0;
    text-align: left;
  }
  
  .search-box-top select {
    border-radius: 25px; 
    padding: 1em 2em; 
    font-size: 1vw; 
    background-color: #f0f4f8; 
    height: auto;
  }
  
  
  .search-box-top select::-ms-expand {
    display: none; 
  }
  
  .search-box-top select { 
    appearance: none; 
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 0.9em;
    padding-left: 20px;
    padding-right: 35px;
    color: #555;
  }
 
  .search-box input {
    box-sizing: border-box;
    width: 100%;
    padding: 25px 40px 25px 20px;
    border-radius: 5px;
    margin: 4vh 0px 1vh 0px;
    font-size: 1.8vw;
  }

  .dropdown {
    width: 80%;
    display: block;
    margin: 0 auto;
  }
  
  .search-box button {
    align-items: center;
    background: #9cc4e4;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 1em;
    cursor: pointer;
    font-size: 1.3vw;
    letter-spacing: 1.2px;
    margin-top: 0.5em;
    margin-bottom: 1em;
    margin-left: auto;
    display: inline-block;
  }
  
  .search-box button:hover {
    background: #0056b3;
  }

  /* Modal */
  .close-button {
    position: absolute;
    top: 5px;
    right: 25px;
    padding: 0px;
    background: none;
    border: none;
    font-size: 24px;
    color: #555;  
    cursor: pointer;
}

.close-button:hover {
    color: #333;  
}

.custom-modal-body ul {
  list-style-type: none;
  padding-left: 3px;
}

.custom-modal-body li {
  margin: 5px 0;
}

.custom-modal-body a {
  text-decoration: none;
  color: #007bff;
  font-size: 16px;
}

.custom-modal-body a:hover {
  text-decoration: underline;
}

.search-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 10px 0 0;
}

  .search-tags span {
    font-size: 0.9vw;
  }

.tag-bubble {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  padding: 0.5em 2em;
  color: white;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  line-height: 1.5;
  -webkit-user-select: none;
          user-select: none;
}

.tag-bubble:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.tag-bubble:active {
  transform: scale(0.98);
}

.tag-bubble.active {
  background: rgba(58, 137, 201, 0.3);
  border-color: #3a89c9;
  box-shadow: 0 0 0 2px rgba(58, 137, 201, 0.2);
}

.example-search {
  display: flex;
  justify-content: flex-start;
  padding-left: 5px;
  font-size: 1vw;
}

/* dropdown button */
.dropdown {
  position: relative;
  display: inline-block;
  width: 80%;
}

.dropbtn {
  width: 100%;
  background: #9cc4e4;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  letter-spacing: 1.2px;
  display: flex;
  gap: 30px;
  justify-content: center;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  width: 100%;
  box-shadow: 0px 8px 16px rgba(0,0,0,0.2);
  z-index: 1;
  border-radius: 5px;
}

.dropdown-content a {
  color: black;
  padding: 12px 15px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gHAAgH;EAClH;;;EAGA,iBAAiB;EACjB;IACE,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,cAAc;IACd,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;AAEF;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;EACE,cAAc;EACd;IACE,8BAA8B;AAClC;;EAEE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;;EAEtB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,4CAA4C;IAC5C,qCAAqC;IACrC,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,gBAAgB;EAChB;IACE,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,YAAY;EACd;;;EAGA;IACE,aAAa;EACf;;EAEA;IAGE,gBAAgB;IAChB,yDAA2D;IAC3D,4BAA4B;IAC5B,sCAAsC;IACtC,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,4BAA4B;IAC5B,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,UAAU;EACV;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;EAEE;IACE,gBAAgB;EAClB;;AAEF;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;EACpC,0BAA0B;EAC1B,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,wCAAwC;EACxC,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* video background */\n.video-background {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n  }\n  \n  .video-background iframe {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100vw;\n    height: 56.25vw;\n    min-width: 100%;\n    min-height: 100%;\n    pointer-events: none;\n  }\n  \n  .video-background::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(91deg, #021a5b 22.01%, rgba(17, 28, 71, 0.76) 64.18%, rgba(17, 28, 71, 0.16) 99.56%);\n  }\n  \n  \n  /* main content */\n  .main-content {\n    color: #fff;\n    padding-bottom: 50px;\n    margin-top: 60px;\n    flex-grow: 1;\n    width: 100%;\n  }\n  \n  .main-content .container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    max-width: 80%;\n    margin: auto;\n  }\n  \n  .content {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 50px;\n    justify-content: center;\n    width: 100%;\n    min-height: 78vh;\n  }\n  \n  .text-column,\n  .search-column {\n    flex: 1 1 45%;\n    min-width: 300px;\n    display: flex;\n    flex-direction: column;\n  }\n\n.text-box,\n.search-box {\n  display: flex;\n  flex-direction: column;\n  flex: 1;               \n}\n  /*text column*/\n  .text-box {\n    justify-content: space-between; \n}\n\n  .text-column h1 {\n    font-size: 2.7vw;\n    font-weight: 700;\n    text-align: left;\n    letter-spacing: 1.3px;\n    margin-top: 0px;\n  }\n  \n  .text-column p {\n    font-size: 1.4vw;\n    text-align: left;\n    line-height: 1.6;\n    letter-spacing: 1.3px;\n    padding-bottom: 25px;    \n\n  }\n  \n  .standout-text {\n    color: #f2c74f;\n    font-weight: 600;\n  }\n  \n  .text-column-buttons {\n    display: flex;\n    gap: 15px;\n    width: 95%;\n  }\n  \n  .text-column-buttons a {\n    flex: 1;\n    text-align: center;\n  }\n  \n  .text-column-buttons button {\n    width: 100%;\n    font-size: clamp(1rem, 0.5rem + 1vw, 2.2rem);\n    padding: clamp(10px, 6px + 1vw, 22px);\n    background-color: #3a89c9;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    letter-spacing: 1.3px;\n  }\n  \n  .text-column_buttons button:hover {\n    background-color: #0056b3;\n  }\n\n  /*search column*/\n  .search-box {\n    background: rgba(255, 255, 255, 0.1);\n    padding: 40px;\n    border-radius: 12px;\n    border: 5px solid #9cc4e4;\n    text-align: center;\n    margin-top: 10px;\n    height: auto !important;\n  }\n  \n  .search-box-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .search-box h2 {\n    font-size: 1.6vw;\n    letter-spacing: 1.3px;\n    margin: 0;\n    text-align: left;\n  }\n  \n  .search-box-top select {\n    border-radius: 25px; \n    padding: 1em 2em; \n    font-size: 1vw; \n    background-color: #f0f4f8; \n    height: auto;\n  }\n  \n  \n  .search-box-top select::-ms-expand {\n    display: none; \n  }\n  \n  .search-box-top select {\n    -webkit-appearance: none; \n    -moz-appearance: none; \n    appearance: none; \n    background-image: url('../assets/chevron-compact-down.svg');\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n    background-size: 0.9em;\n    padding-left: 20px;\n    padding-right: 35px;\n    color: #555;\n  }\n \n  .search-box input {\n    box-sizing: border-box;\n    width: 100%;\n    padding: 25px 40px 25px 20px;\n    border-radius: 5px;\n    margin: 4vh 0px 1vh 0px;\n    font-size: 1.8vw;\n  }\n\n  .dropdown {\n    width: 80%;\n    display: block;\n    margin: 0 auto;\n  }\n  \n  .search-box button {\n    align-items: center;\n    background: #9cc4e4;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    padding: 1em;\n    cursor: pointer;\n    font-size: 1.3vw;\n    letter-spacing: 1.2px;\n    margin-top: 0.5em;\n    margin-bottom: 1em;\n    margin-left: auto;\n    display: inline-block;\n  }\n  \n  .search-box button:hover {\n    background: #0056b3;\n  }\n\n  /* Modal */\n  .close-button {\n    position: absolute;\n    top: 5px;\n    right: 25px;\n    padding: 0px;\n    background: none;\n    border: none;\n    font-size: 24px;\n    color: #555;  \n    cursor: pointer;\n}\n\n.close-button:hover {\n    color: #333;  \n}\n\n.custom-modal-body ul {\n  list-style-type: none;\n  padding-left: 3px;\n}\n\n.custom-modal-body li {\n  margin: 5px 0;\n}\n\n.custom-modal-body a {\n  text-decoration: none;\n  color: #007bff;\n  font-size: 16px;\n}\n\n.custom-modal-body a:hover {\n  text-decoration: underline;\n}\n\n.search-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin: 10px 0 0;\n}\n\n  .search-tags span {\n    font-size: 0.9vw;\n  }\n\n.tag-bubble {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: left;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 16px;\n  padding: 0.5em 2em;\n  color: white;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  line-height: 1.5;\n  user-select: none;\n}\n\n.tag-bubble:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.tag-bubble:active {\n  transform: scale(0.98);\n}\n\n.tag-bubble.active {\n  background: rgba(58, 137, 201, 0.3);\n  border-color: #3a89c9;\n  box-shadow: 0 0 0 2px rgba(58, 137, 201, 0.2);\n}\n\n.example-search {\n  display: flex;\n  justify-content: flex-start;\n  padding-left: 5px;\n  font-size: 1vw;\n}\n\n/* dropdown button */\n.dropdown {\n  position: relative;\n  display: inline-block;\n  width: 80%;\n}\n\n.dropbtn {\n  width: 100%;\n  background: #9cc4e4;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  letter-spacing: 1.2px;\n  display: flex;\n  gap: 30px;\n  justify-content: center;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #f9f9f9;\n  width: 100%;\n  box-shadow: 0px 8px 16px rgba(0,0,0,0.2);\n  z-index: 1;\n  border-radius: 5px;\n}\n\n.dropdown-content a {\n  color: black;\n  padding: 12px 15px;\n  text-decoration: none;\n  display: block;\n}\n\n.dropdown-content a:hover {\n  background-color: #f1f1f1;\n}\n\n.dropdown:hover .dropdown-content {\n  display: block;\n}\n\n.dropdown:hover .dropbtn {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
